import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { socSeverityColor, socStatusColor, socStatusLabel } from "@/lib/utils";
import { ArrowsLeftRight } from "@phosphor-icons/react";

export default function SocHandover() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/soc/handover").then(r => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-5" data-testid="soc-handover-page">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold flex items-center gap-2"><ArrowsLeftRight size={24} /> Shift Handover</h1>
        <p className="text-sm text-muted-foreground mt-1">All open cases with a short status so an incoming analyst can pick up quickly.</p>
      </div>
      <Card className="border-border rounded-sm divide-y divide-border">
        {rows.map(c => (
          <button key={c.id} data-testid={`soc-handover-row-${c.number}`} onClick={() => nav(`/soc/cases/${c.id}`)}
            className="w-full text-left px-4 py-3 hover:bg-accent/20 transition-colors flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <span className="font-mono text-primary text-sm">{c.number}</span>
              <span className="flex-1 truncate text-sm font-medium">{c.title}</span>
              <span className={`text-[10px] font-mono px-2 py-0.5 border ${socSeverityColor(c.severity)}`}>{c.severity}</span>
              <span className={`text-[10px] font-mono px-2 py-0.5 border ${socStatusColor(c.status)}`}>{socStatusLabel(c.status)}</span>
              {c.resolution_breached && <span className="text-[10px] font-mono px-2 py-0.5 border border-rag-red/40 text-rag-red-fg">BREACH</span>}
              {!c.resolution_breached && c.sla_due_soon && <span className="text-[10px] font-mono px-2 py-0.5 border border-rag-amber/50 text-rag-amber-fg">DUE SOON</span>}
            </div>
            <div className="text-xs text-muted-foreground">
              <span className="font-mono">{c.assignee_name || "Unassigned"}</span>
              {c.handover_note ? <span className="ml-2 text-muted-foreground">📌 {c.handover_note}</span> : (c.summary && <span className="ml-2">— {c.summary}</span>)}
            </div>
          </button>
        ))}
        {rows.length === 0 && <div className="px-4 py-10 text-center text-muted-foreground text-sm">No open cases.</div>}
      </Card>
    </div>
  );
}
